<script lang="ts">
    import { getJobPin } from '../components/Location/JobsOnMap';
    import { clientSettings } from '../../stores/api';
    import { get } from 'svelte/store';

    export let color: string;
    export let opts: any = {};
    export let scale: number = 1;
    export let imgStyle: string = '';
    export let label: string = '';
    export let type: 'delivery' | 'collection' | null = 'delivery';
    export let editable: boolean = false;
    export let iconStyle: string = '';

    let input: HTMLInputElement;

    function onClick() {
        if (editable && input) {
            input.click();
        }
    }

    function onLabelClick() {
        if (editable && input) {
            input.click();
        }
    }

    if (iconStyle === '') {
        iconStyle = get(clientSettings).display.icon_style;
    }
</script>

<div class="container" data-color={color} class:container-label={label !== ''}>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <img
        src={getJobPin(color, null, { ...opts, type }, iconStyle).imageUrl}
        alt="color symbol"
        style="transform: scale({scale}); {imgStyle}"
        data-icon-style={iconStyle}
        on:click={onClick}
    />
    {#if editable}
        <input
            bind:this={input}
            class="input-color"
            type="color"
            bind:value={color}
            on:change
            style="width: 0px; height: 0px; overflow: hidden; visibility: hidden; position: absolute"
        />
    {/if}
    {#if label}
        <div class="label" on:click={onLabelClick}>{label}</div>
    {/if}
</div>

<style>
    .container {
        position: relative;
        transform: translate(0, 5%);
        max-width: 40px;
        max-height: 40px;
        cursor: pointer;
    }
    .container-label {
        min-width: 120px;
    }
    .container span {
        position: absolute;
        z-index: 1;
        width: 100%;
        color: #ffffff;
        font-size: 10px;
        line-height: 10px;
        left: 0;
        top: 9px;
        text-align: center;
        min-width: 10px;
        min-height: 10px;
    }
    .label {
        position: absolute;
        left: 33px;
        top: 9px;
        min-width: 80px;
        color: #1d5fc9;
        cursor: pointer;
    }
</style>
